import { gql } from '@apollo/client';

export const WORTH_UPDATE = gql`
	mutation WorthUpdate($companyId: Identifier!, $input: WorthInput!) {
		WorthUpdate(companyId: $companyId, input: $input) {
			worth {
				id
				required
				value
				valueAuto
				wedding
				weddingAuto
				birthday
				birthdayAuto
				corporative
				newYear
				newYearAuto
				graduation
				updatedAt
			}
		}
	}
`;
